import { useWizardStore } from '../../store/wizardStore'
import { Button } from '../ui/Button'
import { CardHeader, CardTitle, CardContent } from '../ui/Card'

export default function Step2GiftDecision() {
  const { setWantsGifts, setWantsSanta, setWantsTokensOnly, nextStep, previousStep, setStep } = useWizardStore()

  const handleYes = () => {
    setWantsGifts(true)
    setWantsTokensOnly(false)
    nextStep() // Go to Step 3: Pickup Location
  }

  const handleNo = () => {
    setWantsGifts(false)
    setWantsTokensOnly(false)
    setStep(5) // Skip to Step 5: Santa Slot Selection
  }

  const handleTokensOnly = () => {
    setWantsGifts(false)
    setWantsSanta(false)
    setWantsTokensOnly(true)
    setStep(7) // Skip to Step 7: Token Purchase
  }

  return (
    <>
      <CardHeader>
        <CardTitle>What would you like to do today?</CardTitle>
        <p className="text-gray-600 mt-2">
          You can do more than one. Start with gifts and you'll be able to book a Santa visit straight after. Activity tokens are offered at the end of every order.
        </p>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <Button
            onClick={handleYes}
            fullWidth
            size="lg"
            variant="primary"
          >
            Buy gifts (and book Santa after)
          </Button>
          <Button
            onClick={handleNo}
            fullWidth
            size="lg"
            variant="outline"
          >
            Book a Santa visit (no gifts)
          </Button>
          <Button
            onClick={handleTokensOnly}
            fullWidth
            size="lg"
            variant="outline"
          >
            Just buy activity tokens
          </Button>
          <div className="pt-4">
            <Button
              onClick={previousStep}
              fullWidth
              variant="ghost"
            >
              Back
            </Button>
          </div>
        </div>
      </CardContent>
    </>
  )
}
